<template>
  <div class="container-fluid d-flex flex-wrap pt-3 main-wrapper bg-dark h-100vh">
      <!-- <div class="col-lg-3 col-12 pl-0 side-nav-bar-custom">
          <SideNav />
      </div> -->
      <div class="col-lg-12 col-12 p-0 mb-5">
          <div class="card">
              <div class="card-header">
                  <div class="row align-items-center">
                      <div class="col-8">
                          <h3 class="mb-0">
                              {{
                                  $store.state.language === "en"
                                      ? "Withdraw"
                                      : "ငွေထုတ်"
                              }}
                          </h3>
                      </div>
                  </div>
              </div>
              <div class="card-body">
                  <form>
                      <h6 class="heading-small">
                          {{
                              $store.state.language === "en"
                                  ? "Account information"
                                  : "အကောင့်ဆိုင်ရာ အချက်အလက်များ"
                          }}
                      </h6>
                      <span class="heading-small">{{
                                  $store.state.language === "en"
                                      ? "User's Balance"
                                      : "လက်ကျန်ငွေ"
                              }} - </span>
                      <span>
                        <b class="text-danger">{{ Number($store.state.amount).toLocaleString() }}</b>
                        ฿
                      </span>

                      <div class="row mt-4">
                                <div class="col-lg-6">
                                    <div class="form-group">
                                      <label
                                          class="form-control-label"
                                          for="input-username"
                                          >{{
                                              $store.state.language === "en"
                                                  ? "Choose Withdraw Banking"
                                                  : "ငွေထုတ်ယူမူပုံစံ ရွေးချယ်ပါ"
                                          }}</label
                                      ><br>
                                      <span class="text-danger">{{
                                          errors.account
                                      }}</span>
                                        <div class="d-flex col-12 flex-wrap p-0 mb-4">
                                            <div class="col-6 px-1 py-1" @click="bankSelection(106)">
                                                <div class="amount-cont py-2 text-left px-3 w-100" :class="bankId === 106 ? 'active' : ''">
                                                    <img src="/build/assets/img/banking/bangkokBank.jpeg" alt="" style="width: 30px; height: 30px; border-radius: 5px;">
                                                    <span class="ml-2">Bangkok Bank</span>
                                                </div>
                                            </div>
                                            
                                            <div class="col-6 px-1 py-1" @click="bankSelection(105)">
                                                <div class="amount-cont py-2 text-left px-3 w-100" :class="bankId === 105 ? 'active' : ''">
                                                    <img src="/build/assets/img/banking/bankOfThailand.jpeg" alt="" style="width: 30px; height: 30px; border-radius: 5px;">
                                                    <span class="ml-2">Bank of Thailand</span>
                                                </div>
                                            </div>
                                            
                                            <div class="col-6 px-1 py-1" @click="bankSelection(107)">
                                                <div class="amount-cont py-2 text-left px-3 w-100" :class="bankId === 107 ? 'active' : ''">
                                                    <img src="/build/assets/img/banking/kasikorn.png" alt="" style="width: 30px; height: 30px; border-radius: 5px;">
                                                    <span class="ml-2">Kasikorn Bank</span>
                                                </div>
                                            </div>

                                            <div class="col-6 px-1 py-1" @click="bankSelection(108)">
                                                <div class="amount-cont py-2 text-left px-3 w-100" :class="bankId === 108 ? 'active' : ''">
                                                    <img src="/build/assets/img/banking/krungthai.png" alt="" style="width: 30px; height: 30px; border-radius: 5px;">
                                                    <span class="ml-2">Krung Thai Bank</span>
                                                </div>
                                            </div>

                                            <div class="col-6 px-1 py-1" @click="bankSelection(110)">
                                                <div class="amount-cont py-2 text-left px-3 w-100" :class="bankId === 110 ? 'active' : ''">
                                                    <img src="/build/assets/img/banking/scb.jpeg" alt="" style="width: 30px; height: 30px; border-radius: 5px;">
                                                    <span class="ml-2">Siam Commercial</span>
                                                </div>
                                            </div>

                                            <div class="col-6 px-1 py-1" @click="bankSelection(109)">
                                                <div class="amount-cont py-2 text-left px-3 w-100" :class="bankId === 109 ? 'active' : ''">
                                                    <img src="/build/assets/img/banking/ttb.png" alt="" style="width: 50px; height: 30px; border-radius: 5px;">
                                                    <span class="ml-2">TMB Thanachart</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                      <!-- <div class="col-lg-6">
                        <div class="form-group">
                            <label class="form-control-label">{{
                                $store.state.language === "en"
                                    ? "QR Code"
                                    : "QR Code"
                            }}</label>

                            <div class="custom-file d-flex">
                                <van-uploader
                                    class="mx-auto"
                                    v-model="imageUploader"
                                    :max-count="1"
                                />
                            </div>
                            <span class="text-danger">{{
                                errors.image
                            }}</span>
                        </div>
                    </div> -->

                      <hr class="my-4" />
                      <div class="pl-lg-4">
                        <span class="text-danger text-xs mb-2" v-if="!$store.state.authUser.bank_account_name && !$store.state.authUser.bank_account_name">{{
                              $store.state.language === "en"
                                  ? "Entered Bank Account and Bank account you want to transfer must be the same."
                                  : "Entered Bank Account and Bank account you want to transfer must be the same."
                          }}</span>
                          <span class="text-danger text-xs mb-2" v-else>{{
                                $store.state.language === "en"
                                    ? "Please contact to your agent to edit Bank Info!"
                                    : "Please contact to your agent to edit Bank Info!"
                            }}</span>
                          
                          
                          <div class="row">
                            <div class="col-lg-6">
                                  <div class="form-group">
                                      <label
                                          class="form-control-label"
                                          for="input-email"
                                          >{{
                                              $store.state.language === "en"
                                                  ? "Account Name"
                                                  : "အကောင့် နာမည်"
                                          }}</label
                                      >
                                      <input
                                          type="text"
                                          id="input-email"
                                          class="form-control"
                                          disabled
                                          v-if="$store.state.authUser.bank_account_name"
                                          v-model="$store.state.authUser.bank_account_name"
                                      />
                                      
                                      <input
                                          class="form-control"
                                          v-else
                                          v-model="
                                              withdrawData.ac_name
                                          "
                                      />
                                      <span class="text-danger">{{
                                          errors.ac_name
                                      }}</span>
                                  </div>
                              </div>

                              <div class="col-lg-6">
                                  <div class="form-group">
                                      <label
                                          class="form-control-label"
                                          for="input-email"
                                          >{{
                                              $store.state.language === "en"
                                                  ? "Account Number"
                                                  : "အကောင့် နံပါတ်"
                                          }}</label
                                      >

                                      <input
                                          type="number"
                                          id="input-email"
                                          class="form-control"
                                          disabled
                                          v-if="$store.state.authUser.bank_account_number"
                                          v-model="$store.state.authUser.bank_account_number"
                                      />
                                      
                                      <input
                                          type="number"
                                          v-else
                                          class="form-control"
                                          v-model="
                                              withdrawData.account_number
                                          "
                                      />
                                      <span class="text-danger">{{
                                          errors.number
                                      }}</span>
                                  </div>
                              </div>
                              <div class="col-lg-6">
                                  <div class="form-group">
                                      <label class="form-control-label">{{
                                          $store.state.language === "en"
                                              ? "Amount"
                                              : "ငွေပမာဏ"
                                      }}</label>
                                      <span class="text-danger text-xs">{{
                                          $store.state.language === "en"
                                              ? ` ( Minimum amount ${(this.$store.state.authUser.parent_id === 7 ? 500 : 300)} ฿ )`
                                              : ` ( အနည်းဆုံး ${(this.$store.state.authUser.parent_id === 7 ? 500 : 300)} ฿ )`
                                      }}</span>
                                      <input
                                          type="number"
                                          id="input-email"
                                          class="form-control"
                                          v-model="withdrawData.amount"
                                      />
                                      <span class="text-danger">{{
                                          errors.amount
                                      }}</span>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div class="pl-lg-4">
                          <div class="form-group">
                              <label class="form-control-label">{{
                                  $store.state.language === "en"
                                      ? "Remark"
                                      : "မှတ်ချက်"
                              }}</label>
                              <textarea
                                  rows="4"
                                  class="form-control"
                                  v-model="withdrawData.remark"
                              ></textarea>
                          </div>
                          <div class="form-group">
                              <button
                                  type="button"
                                  class="btn btn-primary"
                                  @click="sendWithdrawData"
                              >
                                  <div v-if="!isConfirm">
                                      {{
                                          $store.state.language === "en"
                                              ? "Confirm"
                                              : "အတည်ပြုမည်"
                                      }}
                                  </div>
                                  <Loading
                                      color="#ffffff"
                                      v-if="isConfirm"
                                      size="24"
                                      class="px-4 py-0"
                                  />
                              </button>
                          </div>
                      </div>
                  </form>
              </div>
          </div>
      </div>
  </div>
</template>
<script>
import { Toast, Dialog, Loading } from 'vant';
import { mapActions } from 'vuex';
import AccountSelect from './components/AccountSelect.vue';

export default {
components: { AccountSelect, Loading },
data() {
  return {
    imageUploader: [],
    selected_account: {
      account_id: null,
    },
    accounts: [
      {
        name: 'KBZ pay',
        id: 'KBZ pay',
        link: 'https://cdn.gold549.com/build/assets/img/payments/kpay.png',
      },
      {
        name: 'KBZ Mobile Banking',
        id: 'KBZ Mobile Banking',
        link: 'https://cdn.gold549.com/build/assets/img/payments/kbz.png',
      },
      {
        name: 'Wave pay',
        id: 'Wave pay',
        link: 'https://cdn.gold549.com/build/assets/img/payments/wavepay.png',
      },
      {
        name: 'CB Pay',
        id: 'CB Pay',
        link: 'https://cdn.gold549.com/build/assets/img/payments/cb_pay.png',
      },
      {
        name: 'CB Banking',
        id: 'CB Banking',
        link: 'https://cdn.gold549.com/build/assets/img/payments/cbbank.png',
      },
      {
        name: 'AYA Pay',
        id: 'AYA Pay',
        link: 'https://cdn.gold549.com/build/assets/img/payments/ayapay.png',
      },
      {
        name: 'AYA Banking',
        id: 'AYA Banking',
        link: 'https://cdn.gold549.com/build/assets/img/payments/aya.png',
      },

    ],
    account: [],
    // imageUploader: [],
    withdrawData: {},
    errors: {},
    isConfirm: false,
    bankId: null,
  };
},
methods: {
  bankSelection(bankId) {
      this.bankId = bankId;
  },
  ...mapActions(['fetchUser']),
  async sendWithdrawData() {
    try {
      const authUser = await this.fetchUser();
      this.errors = {};
      if (!this.bankId) {
        this.errors.account = this.$store.state.language === 'en'
          ? 'Please pick bank type'
          : 'အကောင့်အမျိုးအစား ရွေးချယ်ပေးပါ။';
        return false;
      }
      if (!this.withdrawData.ac_name && !this.$store.state.authUser.bank_account_number) {
        this.errors.ac_name = this.$store.state.language === 'en'
          ? 'Please enter account name'
          : 'ကျေးဇူးပြု၍ အကောင့်နာမည် ထည့်ပေးပါ။';
        return false;
      }
      if (!this.withdrawData.account_number && !this.$store.state.authUser.bank_account_number) {
        this.errors.number = this.$store.state.language === 'en'
          ? 'Please enter account number'
          : 'အကောင့်နံပါတ် ထည့်သွင်းပေးပါ။';
        return false;
      }
      if (!this.withdrawData.amount) {
        this.errors.amount = this.$store.state.language === 'en'
          ? 'Please enter amount'
          : 'ငွေပမာဏထည့်ပေးပါ။';
        return false;
      }
      if (this.withdrawData.amount < (this.$store.state.authUser.parent_id === 7 ? 500 : 300)) {
        this.errors.amount = this.$store.state.language === 'en'
          ? `Please enter at least ${(this.$store.state.authUser.parent_id === 7 ? 500 : 300)} ฿`
          : `ငွေပမာဏအနည်းဆုံး ${(this.$store.state.authUser.parent_id === 7 ? 500 : 300)}฿ ထည့်ပေးပါ။`;
        return false;
      }

      if (this.withdrawData.amount > authUser.amount) {
        const balanceError = this.$store.state.language === 'en'
          ? "You Don't Have Sufficient Balance"
          : 'အကောင့်ထဲတွင် ပိုက်ဆံအလုံအလောက် မရှိပါ။';
        Dialog.alert({
          message: balanceError,
          confirmButtonText:
                          this.$store.state.language === 'en'
                            ? 'Go Back'
                            : 'နောက်သို့ပြန်သွားမည်။',
        }).then(() => {
          // on close
        });
        return false;
      }
      if (this.isConfirm) {
        return false;
      }
      this.$store.commit(
        'setAmount',
        (this.$store.state.amount -= this.withdrawData.amount),
      );
      this.isConfirm = true;
      // if (this.imageUploader[0]) {
      //   this.withdrawData.transaction_image = this.imageUploader[0].content;
      // }
      this.withdrawData.type = this.selected_account.account_id;
      this.withdrawData.date = this.currentTime;
      this.withdrawData.ac_id = this.bankId;
      const res = await axios.post('/withdraws', this.withdrawData, {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            });
      const resUser = await axios.post(
        `/admin/user/${this.$store.state.authUser.id}`,
        {
          amount: this.withdrawData.amount,
          type: 'withdraw',
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        }
      );
      // this.imageUploader = [];
      this.withdrawData = {};
      this.selected_account.account_id = null;
      Toast.success('Success');
      this.isConfirm = false;
    } catch (error) {
      Toast.success('Fail');
      this.isConfirm = false;
    }
    return true;
  },
  createDateWithTimeZone() {
    const moment = require('moment-timezone');
    const dateInTimeZone = moment.tz(new Date(), 'Asia/Rangoon');
    // Extract individual components from moment object
    const year = dateInTimeZone.year();
    const month = dateInTimeZone.month();
    const day = dateInTimeZone.date();
    const hour = dateInTimeZone.hour();
    const minute = dateInTimeZone.minute();
    const second = dateInTimeZone.second();
    const millisecond = dateInTimeZone.millisecond();

    // Create a new Date object with the extracted components
    const newDateObject = new Date(year, month, day, hour, minute, second, millisecond);
    return newDateObject;
  },
},
//   watch: {
//     'selected_account.account_id': function () {
//       this.account = this.accounts.filter(
//         (account) => account.id === this.selected_account.account_id,
//       );
//     },
//   },
computed: {
  currentTime() {
    return moment(this.createDateWithTimeZone()).format('lll');
  },
},
async mounted() {
  this.$router.push('/manual-withdraw');
  // const authUser = await this.fetchUser();
  // if (!authUser) {
  //   this.$router.push('/auth/login');
  // }
},
};
</script>
<style scoped>
.amount-cont {
    border: 1px solid #ccced0;
    border-radius: 10px;
}

.amount-cont.active {
    background: #dee2e6;
    color: black;
    border: 1px solid 
}

.image-container {
  width: 200px;
  height: 200px;
}
.image-container img {
  width: 100%;
  height: 100%;
  border-radius: 5px;
}
.number-container {
  border-radius: 5px;
  background: #e9ecef;
  justify-content: center;
}
.custom-file {
  height: auto;
}
@media (max-width: 768px) {
  .main-wrapper {
      padding: 7px !important;
  }
}
</style>
